/** @format */

import { useEffect, useState } from "react";

//import components
import HeadTitle from "../../components/global/HeadTitle";

import { ServiceCard } from "../../components/service-card";
//import table data

import { InternalNav } from "../../components/internalNav";
import ShowOrderStatus from "../../components/pops/order_status/orderStatus";
import Table from "../../components/Table2";
import { HistoryAll, HistorySuccess, HistoryWait } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "../../services/dashboard";
import { Spinner1 } from "../../components/spinners/Spinner1";

const OrderHistory = () => {
  const [active, setActive] = useState("all");
  const { orders, loading } = useSelector((state) => state.orders);
  const [servicesOrder, setServicesOrder] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllOrders());
  }, []);
  useEffect(() => {
    if (orders.data?.length) {
      let services = {};
      orders.data.forEach((item) => {
        if (services[item.service_id]) {
          services[item.service_id].count = services[item.service_id].count + 1;
        } else {
          services[item.service_id] = { ...item.service, count: 1 };
        }
      });
      setServicesOrder(Object.values(services));
    }
  }, [orders.data?.length]);
  return (
    <NavbarAndSidebar>
      <ShowOrderStatus type='WAIT' />
      {loading && <Spinner1 />}
      <div className='profile__head mb__small'>
        <HeadTitle title='سجل الطلبات' />
      </div>
      <div className='mb__small' />

      <div className='flex-between service-container'>
        {servicesOrder.map((service) => (
          <ServiceCard key={service.id} item={service} from='order-history' />
        ))}
      </div>
      <div className='mb__small' />

      <InternalNav active={active} setActive={setActive} from='history' />
      <div className='mb__small' />
      {active === "all" && (
        <div>
          <Table
            data={orders.data}
            header={HistoryAll}
            link='/history/'
            // getSearchValue={getSearchValue}
            // searchValues={searchValues}
            name='historyAll'
            hideAction
          />{" "}
        </div>
      )}
      {active === "success" && (
        <div>
          <Table
            data={orders.data.filter((item) => item.status === "completed")}
            header={HistoryAll}
            link='/history/'
            // getSearchValue={getSearchValue}
            // searchValues={searchValues}
            name='historyAll'
            hideAction
          />{" "}
        </div>
      )}
      {active === "wait" && (
        <div>
          <Table
            data={orders.data.filter((item) => item.status === "pending")}
            header={HistoryAll}
            link='/history/'
            // getSearchValue={getSearchValue}
            // searchValues={searchValues}
            name='historyAll'
            hideAction
          />{" "}
        </div>
      )}
      {active === "faild" && (
        <div>
          <Table
            data={orders.data.filter((item) => item.status === "cancelled")}
            header={HistoryAll}
            // link="/profile-guarantor/"
            // getSearchValue={getSearchValue}
            // searchValues={searchValues}
            name='historyAll'
            hideAction
          />{" "}
        </div>
      )}
    </NavbarAndSidebar>
  );
};
export default OrderHistory;
